<script>

    import { createEventDispatcher} from 'svelte'
    import { toast } from 'bulma-toast'

    import UsersService from "../$services/users.service"
    import Input from "./input.text.svelte"

    export let user = null
    export let userId = null
    export let required = true
    export let title = 'Usuario'
    export let role = null

    const dispatch = createEventDispatcher()

    let loading = false
    let showItems = false
    let value = null
    let users = []

    async function getUsersFind() {

        user = null
        userId = null
        showItems = false

        if(value === '')
            return dispatch('select', null)

        if(value.length < 2)
            return

        loading = true
        const resp = await UsersService.getUsersFind({value, role})
        loading = false

        if(!resp.success)
            return toast({ message: resp.error.message, type: "is-danger" })

        users = resp.data

        if(!resp.data.length)
            return

        showItems = true
    }

    function setUser(item) {
        user = item
        userId = item._id
        value = item.email
        showItems = false
        dispatch('select', {user, userId})
    }

</script>

<style>
    .fullwidth {
        width: 100%;
    }
</style>

<!-- svelte-ignore a11y-missing-attribute -->
<div class="field">
    <label for="" class="label">{ title }</label>
    <div class="control">
        <div class="dropdown fullwidth" class:is-active={showItems}>
            <div class="dropdown-trigger fullwidth">
                <Input on:keyup={getUsersFind} bind:value={value} placeholder="Buscar" {required} />
            </div>
            <div class="dropdown-menu fullwidth" id="dropdown-menu" role="menu">
                <div class="dropdown-content fullwidth">
                    {#each users as user}
                        <a on:click={() => setUser(user)} class="dropdown-item fullwidth">{ user.name } {user.email}</a>
                    {/each}
                </div>
            </div>
        </div>
    </div>
</div>